
const TYPES_DOCUMENT = {}
TYPES_DOCUMENT["PV_AUDITION"] = {
    libelle: "PV audition",
    date: "En date du",
};

TYPES_DOCUMENT["CONVOCATION_AUDITION"] = {
    libelle: "Convocation Audition",
    date: "En date du",
};

TYPES_DOCUMENT["OBSERVATIONS"] = {
    libelle: "Demandes d'observations écrites",
    date: "En date du",
};

TYPES_DOCUMENT["PV_AG"] = {
    libelle: "PV Assemblée Générale",
    date: "Date de l'assemblée générale",
};
TYPES_DOCUMENT["STATUTS"] = {
    libelle: "Statuts",
    date: "Date d'adoption des statuts",
};

TYPES_DOCUMENT["ORDONNANCE"] = {
    libelle: "Ordonnance",
    date: "Date de l'ordonnancement",
};

TYPES_DOCUMENT["DECLARATION_INSCR"] = {
    libelle: "Déclaration en vue de l'inscription",
    date: "Date de la déclaration",
};

TYPES_DOCUMENT["TITRE_CONSTITION_DIRECTION"] = {
    libelle: "Titres relatifs à la constitution de la Direction",
};

TYPES_DOCUMENT["DECISION_DIRECTION"] = {
    libelle: "Décision de la direction ",
    date: "Date de la décision",
};

TYPES_DOCUMENT["DECISION_JUDICIAIRE"] = {
    libelle: "Décision judiciaire ou administrative ",
    date: "Date de la décision",
};


TYPES_DOCUMENT["PIECE_ETAT_CIVIL"] = {
    libelle: "Pièce d'état civil ",
};

TYPES_DOCUMENT["AVIS_MINISTERE_PUBLIC"] = {
    libelle: "Avis du ministère public ",
    date: "Date de l'avis ",
};

TYPES_DOCUMENT["JUSTIFICATIF_PAIEMENT"] = {
    libelle: "Justificatif de paiement des frais de publication",
    date: "Date de paiement",
};

TYPES_DOCUMENT["EXTRAIT_PUB_JAL"] = {
    libelle: "Extrait de publication au JAL",
    date: "Date de la publication",
};

TYPES_DOCUMENT["TRAITE_APPORT"] = {
    libelle: "Traité d'apport, scission ou fusion",
    date: "Date du traité",
    dateEffet: "Date d'effet de la fusion",
};

TYPES_DOCUMENT["ATTESTATION_INSCRIPTION"] = {
    libelle: "Attestation d'inscription",
}

TYPES_DOCUMENT["AVIS_FIN_PUBLICATION"] = {
    libelle: "Avis aux fins de publication",
}

TYPES_DOCUMENT["AVIS_INSCRIPTON_PREFECTURE"] = {
    libelle: "Avis d'inscription à la préfecture",
}

TYPES_DOCUMENT["NOTIFICATION_DECISION"] = {
    libelle: "Notification d'une décision en matière de registre des associations",
}


TYPES_DOCUMENT["CERTIFICAT_INSCRIPTION"] = {
    libelle: "Certificat d'inscription",
}

TYPES_DOCUMENT["PIECE_JOINTE"] = {
    libelle: "Pièce jointe",
};

TYPES_DOCUMENT["PIECE_ARCHIVE"] = {
    libelle: "Pièce d'archives",
    date: "Date de la numérisation",
};

TYPES_DOCUMENT["DEMANDE_PIECES"] = {
    libelle: "Demande de pièces",
};

TYPES_DOCUMENT["AVIS_FINS_PAIEMENT"] = {
    libelle: "Avis aux fins de paiement",
};

export function sousTypeDocument(st) {
    if ("EXTRA" === st) {
        return "Extraordinaire"
    } else if ("ORDINAIRE" === st) {
        return "Ordinaire"
    } else if ("CONSTITUTIVE" === st) {
        return "Constitutive"
    } else if ("JUDICIAIRE" === st) {
        return "Judiciaire"
    } else if ("ADMIN" === st) {
        return "Administrative"
    } else if ("PUBDIS" === st) {
        return "Publication de la dissolution";
    } else if ("PUBCRE" === st) {
        return "Publication de la création";
    } else if ("PUBFUS" === st) {
        return "Publication de la fusion";
    } else if ("CREATION" === st) {
        return "Création";
    } else if ("MODIFICATION" === st) {
        return "Modification";
    } else if ("DISSOLUTION" === st) {
        return "Dissolution";
    } else if ("RADIATION" === st) {
        return "Radiation";
    } else if ("FUSION_ABSORPTION" === st) {
        return "Fusion absorption";
    }
    return null;
}


export function libelleDateDocument(d) {
    return TYPES_DOCUMENT[d]?.date;
}

export function libelleDateEffet(d) {
    return TYPES_DOCUMENT[d]?.dateEffet;
}

export function typeDocument(d) {
    return TYPES_DOCUMENT[d]?.libelle || "Type document inconnu";
}
